export const ROUTER_LIST = [
    {
        id: 1,
        name: '签到',
        router_name: 'PluginSignin',
        keywords: ['有订单用户才可签到', '禁止群内签到', '签到奖励金额范围', '是否开启阶梯奖励']
    },
    {
        id: 2,
        name: '查券',
        router_name: 'PluginTicket',
        keywords: ['识别淘口令', '识别商品链接', '识别拼多多商品', '识别京东商品', '追单匹配订单尾号', '前几单使用副联盟', '使用带商品中间页', '消息回复延迟', '促单消息内容', '查询无券消息提醒', '促绑消息内容', '促查消息内容', '自动群返利']
    },
    {
        id: 3,
        name: '视频',
        router_name: 'PluginVipvideo',
        keywords: ['仅会员可解析', '解析收费', '视频解析接口']
    },
    {
        id: 4,
        name: '推广',
        router_name: 'PluginConduct',
        keywords: ['绑定上级奖励金额', '绑定下级奖励金额', '绑定成功上级通知', '绑定成功下级通知', '查券奖励', '开启名片推广方式']
    },
    {
        id: 5,
        name: '海报',
        router_name: 'PluginPoster',
        keywords: ['海报图片']
    },
    {
        id: 6,
        name: '导购',
        router_name: 'PluginGuide',
        keywords: ['自定义导购CMS地址', '是否开启三合一导购开关']
    },
    {
        id: 7,
        name: '账户',
        router_name: 'PluginAccount',
        keywords: ['查询个人信息指令', '用户提现指令', '帮助信息指令', '是否开启自动提现', '无订单用户不可提现', '每日最大提现次数', '最小提现限制金额', '提现超过该金额需要审核', '自动改备注', '红包卡片', '动态更新用户所属群组', '订单异常通知', '停止维权订单检测开关']
    },
    {
        id: 8,
        name: '基础设置',
        router_name: 'BasicSetting',
        keywords: ['自动同意入群申请', '自动同意好友申请', '每天同意好友请求个数', '自动同意好友申请间隔', '添加好友主动发消息', '添加好友招呼消息设置', '首次添加好友奖励', '返利群组入群欢迎消息', '首次下单奖励金额', '付款即奖励', '订单冻结天数', '添加好友邀请入群', '消息互换', '自动清理微信缓存', '静默更新', '购买链接使用短链接', '订单消息通知', '消息强制推送到群组', '开启呼叫客服功能', '开启后通过公众号消息通知','IM客服系统开关']
    }
]